import React from 'react';
import axios from 'axios';
import { MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle } from "mdb-react-ui-kit";
import { exportToPDF, exportToCSV } from "../../../helper/exportDatatable";

const exportColumns = [
    { field: "type", header: "Type" },
    { field: "rawAmendment", header: "Amendment" },
    { field: "rawCondensed", header: "Condensed Version" },
    { field: "drafterInfo", header: "Drafter" },
    { field: "requestorInfo", header: "Requester" }
];

const fetchRequestorName = async (requestorId) => {
    if (!requestorId || requestorId === '') return 'N/A';
    
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/legislators/${requestorId}`
        );
        const data = response.data;
        return data.lastName || data.firstName 
            ? `${data.lastName || ''}, ${data.firstName || ''}`.trim()
            : 'N/A';
    } catch (error) {
        console.error("Error fetching requestor name: ", error);
        return 'N/A';
    }
};

const fetchDrafterName = async (requestorId) => {
    if (!requestorId || requestorId === '') return 'N/A';

    try {
        const response = await axios.get(
            `${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/staffMembers/${requestorId}`
        );
        const data = response.data;
        return data.lastName || data.firstName
            ? `${data.lastName || ''}, ${data.firstName || ''}`.trim()
            : 'N/A';
    } catch (error) {
        console.error("Error fetching drafter name: ", error);
        return 'N/A';
    }
};

export const AmendmentsExport = ({ amendmentsData, bill, handlePdfUrlFetch }) => {
    const handlePDFExport = async () => {
        const dataWithNames = await Promise.all(
            amendmentsData.map(async (row) => ({
                ...row,
                requestorInfo: await fetchRequestorName(row.requestorInfo?.requestorId),
                drafterInfo: await fetchDrafterName(row.drafterInfo?.drafterId)
            }))
        );

        exportToPDF(
            "Amendments",
            `${bill?.billType?.code}${bill?.billNumber}`,
            exportColumns,
            dataWithNames,
            { columnStyles: null }
        );
    };

    const handleCSVExport = async () => {
        const dataWithUrls = await Promise.all(
            amendmentsData.map(async (row) => {
                const amendmentUrl = await handlePdfUrlFetch(row.amendmentId);
                const condensedUrl = row.condensedId 
                    ? await handlePdfUrlFetch(row.condensedId) 
                    : 'No Condensed Version';
                
                return {
                    Type: row.type,
                    Amendment: row.rawAmendment,
                    AmendmentURL: amendmentUrl,
                    Condensed: row.rawCondensed,
                    CondensedURL: condensedUrl,
                    Drafter: await fetchDrafterName(row.drafterInfo?.drafterId),
                    Requestor: await fetchRequestorName(row.requestorInfo?.requestorId),
                    RequestorType: "LEGISLATOR"
                };
            })
        );

        exportToCSV(
            "Amendments",
            `${bill?.billType?.code}${bill?.billNumber}`,
            [
                { field: "Type", header: "Type" },
                { field: "Amendment", header: "Amendment" },
                { field: "AmendmentURL", header: "Amendment URL" },
                { field: "Condensed", header: "Condensed Version" },
                { field: "CondensedURL", header: "Condensed URL" },
                { field: "Drafter", header: "Drafter" },
                { field: "Requestor", header: "Requester" },
                { field: "RequestorType", header: "Requester Type" },
            ],
            dataWithUrls
        );
    };

    return (
        <MDBDropdown className="d-flex justify-content-end mb-3">
            <MDBDropdownToggle>
                <i className="fa-light fa-cloud-arrow-down" aria-hidden="true"></i>{" "}
                Export
            </MDBDropdownToggle>
            <MDBDropdownMenu>
                <MDBDropdownItem
                    link
                    onClick={(e) => {
                        e.preventDefault();
                        handleCSVExport();
                    }}
                >
                    Excel/CSV
                </MDBDropdownItem>
                <MDBDropdownItem
                    link
                    onClick={(e) => {
                        e.preventDefault();
                        handlePDFExport();
                    }}
                >
                    Print/PDF
                </MDBDropdownItem>
            </MDBDropdownMenu>
        </MDBDropdown>
    );
}; 